/**
 * Created by zoechodosh on 1/17/17.
 */
export const REQUEST_ADDRESS = 'zola/places/REQUEST_ADDRESS';
export const RECEIVE_ADDRESS = 'zola/places/RECEIVE_ADDRESS';
export const RESET_ADDRESS = 'zola/places/reset_address';



/** WEBPACK FOOTER **
 ** ./src/actions/types/PlacesActionTypes.js
 **/